let timeLeftInSeconds = 0;
let originalSessionTimeoutInSeconds = 0;
const intervalInSeconds = 1;
let sessionModal = document.getElementById('session-timeout-modal');

function initSessionTimeoutUtil(sessionTimeoutInMinutes) {
  if (sessionTimeoutInMinutes == 0) {
    sessionTimeoutInMinutes = 60;
  }
  const customSessionTimeout = getCookie('customSessionTimeout');

  originalSessionTimeoutInSeconds = (customSessionTimeout ? customSessionTimeout : sessionTimeoutInMinutes) * 60;
  timeLeftInSeconds = originalSessionTimeoutInSeconds;

  initEventListners();
  runInterval();
}

function runInterval() {
  const interval = setInterval(() => {
    timeLeftInSeconds -= intervalInSeconds;

    if (timeLeftInSeconds < 1) {
      signOut();
      clearInterval(interval);
    } else if (timeLeftInSeconds < 5 * 60 && !isSessionModalVisible()) {
      showSessionModal();
    }

    if (isSessionModalVisible()) {
      updateModalTime();
    }
  }, intervalInSeconds * 1000);
}

function signOut() {
  location.href = '/RRDCommon/SignOut.aspx';
}

function updateModalTime() {
  let minutes = Math.floor(timeLeftInSeconds / 60);
  let seconds = timeLeftInSeconds - minutes * 60;
  document.getElementById('modal-time-left-container').textContent = `${format(minutes)}:${format(seconds)}`;
}

function format(string) {
  let length = 2;
  return (new Array(length + 1).join('0') + string).slice(-length);
}

function activityDetected(e) {
  if (!isSessionModalVisible()) {
    timeLeftInSeconds = originalSessionTimeoutInSeconds;
  }
}

function initEventListners() {
  document.addEventListener('mousemove', activityDetected);
  document.addEventListener('keypress', activityDetected);

  document.getElementById('modal-prolong-session-btn').addEventListener('click', function() {
    timeLeftInSeconds = originalSessionTimeoutInSeconds;
    hideSessionModal();
  });
  document.getElementById('modal-sign-out-btn').addEventListener('click', function() {
    signOut();
  });
}

function showSessionModal() {
  sessionModal.style.display = 'block';

  var backdropEl = document.createElement('div');
  backdropEl.id = 'session-backdrop';
  document.body.appendChild(backdropEl);
}

function isSessionModalVisible() {
  return sessionModal.style.display === 'block';
}

function hideSessionModal() {
  sessionModal.style.display = 'none';

  var backdropEl = document.getElementById('session-backdrop');
  backdropEl.parentNode.removeChild(backdropEl);
}

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export { initSessionTimeoutUtil };
